import React, { ForwardedRef } from 'react';
import { useTabListState } from '@react-stately/tabs';
import { UnderlinedTab } from './UnderlinedTab';
import { TabsProps, UnderlinedTabsProps } from '../TabsProps';
import { TabPanelWrapper } from '../TabPanelWrapper';
import { UnderlinedTabsList } from './UnderlinedTabsList';
import { useTabList } from '@react-aria/tabs';
import { useObjectRef } from '@react-aria/utils';

function Tabs<T extends object>(
  props: TabsProps<T> & UnderlinedTabsProps,
  ref: ForwardedRef<HTMLDivElement>
): JSX.Element {
  const tabListRef = useObjectRef(ref);

  const state = useTabListState({
    ...props,
    isDisabled: props.isDisabled,
    children: props.children,
  });

  const { tabListProps } = useTabList(props, state, tabListRef);

  return (
    <>
      <UnderlinedTabsList
        {...props}
        tabListProps={tabListProps}
        ref={tabListRef}
      >
        {Array.from(state.collection).map((item) => (
          <UnderlinedTab key={item.key} item={item} state={state} />
        ))}
      </UnderlinedTabsList>
      <TabPanelWrapper state={state} keepMounted={props.keepMounted} />
    </>
  );
}

// NOTE: couldn't use ts-expect-error because in storybook the error is inconsistent in building and storybook typechecking
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Expression produces a union type that is too complex to represent.
export const UnderlinedTabs = React.forwardRef(Tabs);
